/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsWebPushOptions, FxIdDomainSettingsWebPushOptionsFromJSONTyped, FxIdDomainSettingsWebPushOptionsToJSON, } from './FxIdDomainSettingsWebPushOptions';
export function FxIdDomainSettingsPublicWebClientConfigOptionsWebPushFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsWebPushFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsWebPushFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsWebPushOptions(json)) {
        return FxIdDomainSettingsWebPushOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsWebPushToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsWebPushToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsWebPushToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsWebPushOptions(value)) {
        return FxIdDomainSettingsWebPushOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsWebPush.js.map